import useCurrencyText from 'hooks/shared/useCurrencyText';
import { useTranslation } from 'react-i18next';

interface OrderListItemInfoRow {
  label: string;
  value: string;
  fieldId?: 'status';
}

type Result = (order: OrderListItem) => OrderListItemInfoRow[];

const useOrderListItemInfoRows = (): Result => {
  const { t } = useTranslation();

  const currencyText = useCurrencyText();

  return (order: OrderListItem) => [
    {
      label: t('recommendedOrderStatus'),
      value: order.status.description,
      fieldId: 'status',
    },
    {
      label: t('recommendedOrderQuantity'),
      value: order.quantity.toString(),
    },
    {
      label: t('recommendedOrderPrice'),
      value: currencyText(order.price, { symbol: order.currency.symbol }),
    },
    {
      label: t('recommendedOrderTotal'),
      value: currencyText(order.amount, {
        symbol: order.currency.symbol,
      }),
    },
  ];
};

export default useOrderListItemInfoRows;
